import * as type from '../constants';

export const changeLotteryConfig = (config) => ({
    type: type.CHANGE_LOTTERY_CONFIG,
    config
});
